import { ProcedureStepEventType, ProcedureStepFieldValuesReviewType, type User } from "@overmap-ai/common"

export const getTimelineDate = (model: {
	submitted_at?: string | null
	created_at?: string | null
	updated_at?: string | null
}) => {
	return model.submitted_at ?? model.created_at ?? model.updated_at ?? ""
}

export const createUserIdList = (...ids: (User["id"] | null | undefined)[]) => {
	return Array.from(new Set(ids.filter((id): id is User["id"] => typeof id === "number")))
}

const procedureStepEventLabels = {
	[ProcedureStepEventType.ADD_ASSIGNEE]: "added an assignee",
	[ProcedureStepEventType.REMOVE_ASSIGNEE]: "removed an assignee",
	[ProcedureStepEventType.ADD_REVIEWER]: "added a reviewer",
	[ProcedureStepEventType.REMOVE_REVIEWER]: "removed a reviewer",
} as const satisfies Record<ProcedureStepEventType, string>

export const procedureStepEventLabel = (type: ProcedureStepEventType) => {
	return procedureStepEventLabels[type]
}

const procedureStepReviewLabels = {
	[ProcedureStepFieldValuesReviewType.APPROVED]: "approved",
	[ProcedureStepFieldValuesReviewType.REJECTED]: "rejected",
	[ProcedureStepFieldValuesReviewType.CHANGES_REQUESTED]: "requested changes on",
} as const satisfies Record<ProcedureStepFieldValuesReviewType, string>

export const procedureStepReviewLabel = (type: ProcedureStepFieldValuesReviewType) => {
	return procedureStepReviewLabels[type]
}
